import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import isEqual from "lodash.isequal";
import get from "lodash.get";
import JoinCouponText from "./JoinCouponText";
import PopupLayer from "../common/PopupLayer";
import { getPopupURL } from "../../../app/Helper/CommonHelper";
import { getCouponLayerOptions } from "../../../app/Helper/CouponHelper";

/**
 * 신규회원 쿠폰
 */
function JoinCoupon() {
  const joinCouponRef = useRef(null);
  const { couponsSummary } = useSelector(
    (state) => ({
      couponsSummary: state.default.couponsSummary
        ? state.default.couponsSummary.response
        : {},
    }),
    isEqual
  );

  const { newMemberCoupon = {} } = get(
    couponsSummary,
    ["data", TMON.htStaticData.sDealNo],
    {}
  );

  const discountAmount = get(
    newMemberCoupon,
    ["couponDisplaySummary", "discountAmount"],
    0
  );
  const discountPercent = get(
    newMemberCoupon,
    ["couponDisplaySummary", "discountPercent"],
    0
  );

  const isNewDisplay =
    !TMON.oApp.oUtil.isEmpty(newMemberCoupon) &&
    newMemberCoupon.couponDisplaySummary.displayType !== "NONE" &&
    ((typeof discountAmount === "number" && discountAmount > 0) ||
      (typeof discountPercent === "number" && discountPercent > 0));

  // 팝업 레이어
  const [isNewMemberLayerOpen, setIsNewMemberLayerOpen] = useState(false);

  const handleNewMemberLayerOpen = () => {
    TMON.sendLog(null, [
      joinCouponRef.current,
      null,
      {
        "tl:area": "DDCN",
        "tl:dimension": `main_deal_srl:${TMON.htStaticData.htDealInfo.dealNo}`,
      },
    ]);

    if (TMON.oApp.sPlatform === "MA") {
      // data parameter 개선을 위해 localstorage 사용
      const couponLayerOptions = getCouponLayerOptions();
      localStorage.setItem(
        "deal_popup_data",
        JSON.stringify({
          ...couponLayerOptions,
          dealSrls: String(TMON.htStaticData.htDealInfo.dealNo),
        })
      );
      TMON.app.callApp(
        "webview",
        "showView",
        "신규회원 쿠폰 혜택",
        getPopupURL("join_coupon"),
        true
      );
    } else {
      setIsNewMemberLayerOpen(true);
    }
  };

  return (
    isNewDisplay && (
      <div className="deal_info_unit join_coupon">
        <div className="info_unit_title">
          <h3 className="title">신규회원</h3>
        </div>
        <div className="info_unit_contents">
          <div
            className="info_unit_button"
            role="button"
            onClick={handleNewMemberLayerOpen}
            ref={joinCouponRef}
          >
            <div className="info_unit_newmember">
              <JoinCouponText coupons={newMemberCoupon} />
              <img
                src={`${
                  TMON.htStaticData.sFeRepoImgPath
                }/img/deals/img_new_member.png`}
                alt="가입쿠폰"
                className="icon_newmember"
              />
            </div>
          </div>
          {isNewMemberLayerOpen && (
            <PopupLayer
              title="신규회원 쿠폰 혜택"
              popupKey="join_coupon"
              onClose={() => setIsNewMemberLayerOpen(false)}
              layerOptions={{
                ...getCouponLayerOptions(),
              }}
            />
          )}
        </div>
      </div>
    )
  );
}

export default JoinCoupon;
